import InfoIconCard from "components/icons/IconInfoCard"
import Tooltip from "components/Tooltip"
import BodyText from "components/Typography/BodyText"
import Heading from "components/Typography/Heading"
import { ReactNode, memo, useMemo } from "react"
import styled from "styled-components"
import { formatPrice } from "utils/formatPrice"
import VariationDisplay from "../VariationDisplay"

const InfoCard = styled.div`
  height: 150px;
  background: ${(props) => props.theme.palette.white};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  padding: 20px 24px 16px 24px;
  gap: 8px;
`

const TextInfoCard = styled.div`
  width: 194px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.palette.gray_ice};
`

interface MetricsCardItemProps {
  icon: ReactNode
  value: App.MetricsSummary
  description: string
  tooltipText: string
  isPrice?: boolean
}

const MetricsCardItem = (props: MetricsCardItemProps) => {
  const { icon, value, description, tooltipText, isPrice } = props

  const formatResult = useMemo(() => {
    const totalValue = value.total

    if (isPrice) return formatPrice(totalValue, "BRL")

    return totalValue
  }, [value, isPrice])

  return (
    <InfoCard>
      <IconWrapper>{icon}</IconWrapper>
      <TextInfoCard>
        <Heading variant="h4">{formatResult}</Heading>
        <DescriptionContainer>
          <BodyText color="gray-dark" weight="bold" size="small">
            {description}
          </BodyText>
          <Tooltip text={tooltipText} toolTipClassName="position-absolute" hoverClassName="positon-unset fit-content">
            <InfoIconCard />
          </Tooltip>
        </DescriptionContainer>

        <Divider />
        <VariationDisplay value={value} isPrice={isPrice} />
      </TextInfoCard>
    </InfoCard>
  )
}

export default memo(MetricsCardItem)
